export const memberPostNotificationSettingsFields = () => `
  __typename
  enabled
  memberId
  postId
`;
//# sourceMappingURL=memberPostNotificationSettings.fields.js.map